import React, { useEffect, useState } from 'react'
import CommonBanner from '../../components/common/CommonBanner'
import Banner from "../../Assets/Blog/BlogBanner.png";
import BlogDetails from '../../components/User/Blog/BlogDetails';
import { useParams } from 'react-router-dom';
import blogs from "../../config/blog.json"
import BlogDetailsSkeleton from '../../components/User/Blog/BlogDetailsSkeleton';

const BlogDetail = () => {
  const { id } = useParams()
  const [blog, setBlog] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    try {
      setLoading(true)
      const fetchedBlog = blogs.find(b => b.id === id)
      setBlog(fetchedBlog)
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }, [id])

  return (
    <div>
      <CommonBanner backgroundImage={Banner} title="Blog Details" subheading="Home/Blog" />
      {
        loading ?
          <BlogDetailsSkeleton /> : <BlogDetails blog={blog} />
      }
    </div>
  )
}

export default BlogDetail